export class LogoutRedirectUrlGetResponse {
  redirectTo?: string
}
